import React from 'react';
import { Link } from 'react-router-dom';

const reviews = [
  {
    text: 'Waking up to the still waters of Khuvsgul Lake from our suite was something I will never forget. The suite was immaculate, the staff anticipated every need before we even asked, and the spa was an absolute sanctuary. Black Rock is not just a hotel — it is an experience.',
    author: 'Sarah M. — United Kingdom',
  },
  {
    text: 'We celebrated our anniversary here and it exceeded every expectation. The Khuvsgul Suite is breathtaking — floor-to-ceiling views, a perfectly designed interior, and an atmosphere of complete tranquility. The team arranged a private lakeside dinner that was simply magical.',
    author: 'James & Lena K. — Germany',
  },
  {
    text: 'I travel frequently for work and leisure, but Black Rock stands apart. The harmony between the raw Mongolian landscape and the refined luxury of the property is rare. The spa treatments, the cuisine, the silence of the lake at dawn — everything was flawless.',
    author: 'Hiroshi T. — Japan',
  },
];

const amenities = [
  { icon: 'fa-bed',                  title: 'Suites',          desc: 'Suites offer comfort and elegance.' },
  { icon: 'fa-star',                 title: 'Experiences',     desc: 'Activities, Nearby Attractions & Others.' },
  { icon: 'fa-tree',                 title: 'Outdoor Spaces',  desc: 'Outdoor spaces inspire peaceful relaxation.' },
  { icon: 'fa-hands-helping',        title: 'Services',        desc: 'Services exceed guest expectations.' },
  { icon: 'fa-spa',                  title: 'Spa & Wellness',  desc: 'Spa and wellness rejuvenate the soul.' },
  { icon: 'fa-hand-holding-medical', title: 'Treatment',       desc: 'Recovery and treatment ensure holistic healing.' },
];

function OtherHomeSection() {
  return (
    <>

      {/* ── About ── */}
      <section className="hs-about">
        <div className="container">
          <div className="hs-about__inner">

            {/* Images */}
            <div className="hs-about__imgs">
              <img src={`${process.env.PUBLIC_URL}/img/about01.jpg`} alt="" className="hs-about__img hs-about__img--top" />
              <img src={`${process.env.PUBLIC_URL}/img/about04.jpg`} alt="" className="hs-about__img hs-about__img--bot" />
            </div>

            {/* Text */}
            <div className="hs-about__text">
              <div className="hs-about__label">Where Luxury Meets Nomadic Spirit</div>
              <h2 className="hs-about__title">Discover Black Rock</h2>
              <div className="hs-about__divider" />
              <p className="hs-about__lead">
                At Black Rock, we blend the timeless traditions of nomadic culture with modern luxury to create a unique boutique resort experience nestled in the heart of Asian Blue Pearl.
              </p>
              <p className="hs-about__body">
                We offer a serene sanctuary where comfort, culture, and nature unite — featuring a world-class spa and thoughtful design inspired by Mongolia's beauty.
              </p>
              <Link to="/about" className="hs-about__btn">Discover Our Story</Link>
            </div>

          </div>
        </div>
      </section>

      {/* ── Reviews ── */}
      <section className="hs-reviews bg-img bg-fixed" data-overlay-dark="7" style={{ backgroundImage: `url(${process.env.PUBLIC_URL}/img/banner/02.jpg)` }}>
        <div className="hs-reviews__deco">"</div>
        <div className="container" style={{ position: 'relative', zIndex: 1 }}>
          <div className="hs-reviews__head">
            <div className="hs-reviews__label">Guest Experiences</div>
            <h2 className="hs-reviews__title">What Our Guests Say</h2>
            <div className="hs-reviews__divider" />
          </div>
          <div className="hs-reviews__grid">
            {reviews.map(function(r, i) { return (
              <div key={i} className="hs-review-card">
                <div className="hs-review-card__top-bar" />
                <div className="hs-review-card__stars">
                  {[1,2,3,4,5].map(function(s) { return <i key={s} className="hs-star" />; })}
                </div>
                <p className="hs-review-card__text">"{r.text}"</p>
                <div className="hs-review-card__foot">
                  <div className="hs-review-card__line" />
                  <div className="hs-review-card__author">{r.author}</div>
                </div>
              </div>
            ); })}
          </div>
        </div>
      </section>

      {/* ── Amenities ── */}
      <section className="hs-amenities">
        <div className="container">
          <div className="hs-amenities__inner">

            {/* Left: header */}
            <div className="hs-amenities__header">
              <div className="hs-amenities__label">Black Rock Services</div>
              <h2 className="hs-amenities__title">Amenities</h2>
              <div className="hs-amenities__divider" />
              <p className="hs-amenities__desc">
                From elegant accommodations and a rejuvenating spa to scenic outdoor spaces and personalized services, every amenity is thoughtfully designed to make your stay unforgettable.
              </p>
            </div>

            {/* Right: cards */}
            <div className="hs-amenities__grid">
              {amenities.map(function(a) { return (
                <div key={a.title} className="hs-am-card">
                  <div className="hs-am-card__icon">
                    <i className={`fa-thin ${a.icon}`}></i>
                  </div>
                  <h5 className="hs-am-card__title">{a.title}</h5>
                  <p className="hs-am-card__desc">{a.desc}</p>
                </div>
              ); })}
            </div>

          </div>
        </div>
      </section>

    </>
  );
}

export default OtherHomeSection;
